require 'utilities/template.coffee'

PT.SwicusChecker = class SwicusChecker
  constructor: (@url) ->
    @emailField = $("[data-swicus-check]")
    @signupForm = $("[data-signup-form]")
    @swicusIntercept = $("[data-swicus-intercept]")

    @initBindings()

  initBindings: ->
    @emailField.on "blur", @onEmailFieldBlur

  onEmailFieldBlur: (e) =>
    $.getJSON @url, { email: e.target.value }, (data) =>
      if data.has_account
        $html = $(@renderTemplate())
        $html.on "click", "[data-swicus-intercept-ignore]", @onIgnoreSwicusIntercept
        @swicusIntercept.html($html)

        @signupForm.fadeOut('fast')
        @swicusIntercept.slideDown('fast')

  onIgnoreSwicusIntercept: (e) =>
    e.preventDefault()

    @swicusIntercept.fadeOut('fast', () =>
      @signupForm.fadeIn('fast')
      @emailField.val('').focus()
    )

  renderTemplate: ->
    @template ||= PT.Utils.Template('signups/swicus_intercept')
    @template()